<template>
  <!-- 船期查询 -->
  <div class="page-container" id="ebOrderContainer">
    <el-form :model="searchData" ref="ruleFormRef" class="form-panel" label-position="top"
             :validateOnRuleChange="false">
      <el-row class="content-panel top-radius">
        <el-row :gutter="22">
          <el-row :gutter="10" style="margin: 5px">
            <el-col :span="4">
              <el-form-item label="船公司:">
                <el-associate
                  style="width: 100%"
                  :columns="associate_columns_carrier"
                  :query-method="associate_queryMethod_carrier"
                  class="input_length"
                  clearable
                  :query-length="0"
                  :default-first-option="true"
                  label-prop="custAlias"
                  value-prop="custNameCn"
                  placeholder=""
                  v-model="searchData.carrierName"
                  @change="onChangeCarrie"
                  size="mini"
                  case="upper"
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-row>
                <el-col :span="16">
                  <el-form-item label="船名/航次:">
                    <el-associate
                      style="width: 100%"
                      :columns="associate_columns_vessel"
                      :query-method="associate_queryMethod_vessel"
                      class="input_length"
                      clearable
                      :query-length="0"
                      :default-first-option="true"
                      label-prop="vesselName"
                      value-prop="mdVoyagePlanId"
                      placeholder=""
                      v-model="searchData.vesselName"
                      size="mini"
                      @change="onChangeVessel"
                      case="upper"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item>
                    <label slot="label" class="label_no"></label>
                    <el-input
                      size="mini"
                      placeholder=""
                      clearable
                      v-model="searchData.voyage"
                    >
                    </el-input>
<!--                    <el-associate
                      style="width: 100%"
                      :columns="associate_columns_voyage"
                      :query-method="associate_queryMethod_voyage"
                      class="input_length"
                      clearable
                      :query-length="0"
                      :default-first-option="true"
                      label-prop="voyage"
                      value-prop="voyage"
                      placeholder=""
                      v-model="searchData.voyage"
                      size="mini"
                      name="voyage"
                        case="upper"
                    />-->
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-col :span="12">
                <el-form-item label="装货港:">
                  <el-associate
                    style="width: 100%"
                    :columns="associate_columns_po"
                    :query-method="associate_queryMethod_po"
                    class="input_length"
                    clearable
                    :query-length="0"
                    :default-first-option="true"
                    label-prop="portNameEn"
                    value-prop="mdPortId"
                    @change="onPolChange"
                    placeholder=""
                    v-model="searchData.polId"
                    size="mini"
                    name="polName"
                    case="upper"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="卸货港:">
                  <el-associate
                    style="width: 100%"
                    :columns="associate_columns_po"
                    :query-method="associate_queryMethod_po"
                    class="input_length"
                    clearable
                    :query-length="0"
                    :default-first-option="true"
                    label-prop="portNameEn"
                    value-prop="mdPortId"
                    @change="onPodChange"
                    placeholder=""
                    v-model="searchData.podId"
                    size="mini"
                    name="podName"
                    case="upper"
                  />
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="开航日期从:">
                    <el-date-picker
                      v-model="searchData.etdFrom"
                      align="right"
                      type="date"
                      style="width: 100%"
                      size="mini"
                      placeholder=""
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="开航日期到:">
                    <el-date-picker
                      v-model="searchData.etdTo"
                      align="right"
                      type="date"
                      style="width: 100%"
                      size="mini"
                      placeholder=""
                      :picker-options="pickerOptions"
                      @change="changeEndEtd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="4" style="padding-top: 17px">
              <el-row type="flex" justify="start" align="right" :gutter="10" class="el-row-margin">
                <el-button class="el-button-search" type="primary" size="small" plain @click="queryForm">查询</el-button>
                <el-button type="info" size="small" plain @click="resetForm">重置</el-button>
              </el-row>
            </el-col>
          </el-row>
        </el-row>
        <!-- </div> -->

        <!-- 表格-start -->
        <el-row style="margin-top: 15px">
          <hot-table ref="ebOrderTableRef" :data-source="shippingDateTableDataSource"
                     :settings="shippingDateTableSettings" col-settings-key="shippingDate">
            <hot-column :has-tip="true" data="vesselName" title="中/英文船名" width="150"></hot-column>
            <hot-column :has-tip="true" data="voyage" title="航次" width="150"></hot-column>
            <hot-column :has-tip="true" date-format="YYYY-MM-DD" data="eta" title="预抵日期" width="150"></hot-column>
            <hot-column :has-tip="true" date-format="YYYY-MM-DD" data="etd" title="预离日期" width="150"></hot-column>
            <hot-column :has-tip="true" data="carrierName" title="船公司" width="150"></hot-column>
            <hot-column :has-tip="true" data="shippingAgencyName" title="船代公司" width="150"></hot-column>
            <hot-column :has-tip="true" data="callingPortName" title="装货港" width="150"></hot-column>
            <hot-column :has-tip="true" data="portDestinationName" title="卸货港" width="150"></hot-column>
          </hot-table>

        </el-row>
        <!-- 分页start -->
        <div class="pg_div">
          <el-pagination :current-page="pageConfig.currentPage" :layout="pageConfig.layout"
                         :page-size="pageConfig.pageSize" :page-sizes="pageConfig.pageSizes" :total="pageConfig.total"
                         @current-change="handleCurrentChange" @size-change="handleSizeChange"/>
        </div>
        <!-- 分页end -->
        <!-- 表格-end -->

      </el-row>
    </el-form>
  </div>
</template>

<script>
import { queryShippingDate } from "@/api/queryMainSystem";
import { queryCarrierInfo, queryPoInfo, queryVoyageInfo } from "@/api/commonService";

export default {
  name: "ShippingDate",
  data() {
    return {
      // 船公司联想控件
      associate_columns_carrier: [
        {
          title: "中文简称",
          field: "custAlias",
        },
        {
          title: "中文全称",
          field: "custNameCn",
        },
        {
          title: "助记码",
          field: "mnemonicCode",
        },
      ],
      // 船名联想控件
      associate_columns_vessel: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
      ],
      // 航次联想控件
      associate_columns_voyage: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
        {
          title: "航次代码",
          field: "voyageCode",
        },
      ],
      // 装/卸货港联想控件
      associate_columns_po: [
        {
          title: "英文名称",
          field: "portNameEn",
        },
        {
          title: "中文名称",
          field: "portNameCn",
        },
        {
          title: "国家代码",
          field: "countryCode",
        },
        {
          title: "海港代码",
          field: "portCode",
        },
      ],
      //日期设置
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      shippingDate: {
        vesselName: null,
        voyage: null,
        eta: null,
        etd: null,
        carrierName: null,
        shippingAgencyName: null,
        callingPortName: null,
      },
      searchData: {
        carrierName: null,
        vesselName: null,
        voyage: null,
        polName: null,
        podName: null,
        etdFrom: null,
        etdTo: null,
        callingPortName: null,
        portDestinationName: null
        // etdFrom: new Date(new Date(new Date(new Date().getTime() - 24*1000*3600*60).toLocaleDateString()).getTime()),
        // etdTo: new Date(new Date(new Date(new Date().getTime() + 24*1000*3600*31).toLocaleDateString()).getTime() + 24*1000*3600 -1)
      },

      // 分页
      pageConfig: {
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        pageSize: 100,
        pagerCount: 100,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100]
      },
      flag: 0,
      // 表格校验
      ebOrderRules: {},
      // 表格数据
      shippingDateTableDataSource: [],
      // 表格设置
      shippingDateTableSettings: {
        height: 520,
        stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig
      },
      pageID: {},
    };
  },
  async created() {

  },
  mounted() {
    let self = this
    this.flag = this.$route.query.flag? this.$route.query.flag : 0
    if(self.flag === 1) {
      self.searchData=this.$route.query.searchData
      self.queryForm()
      }

    // 监听外层容器div宽度的变化，做表格自适应
    //     self.pageID = document.getElementById('ebOrderContainer')
    //     this.$tableAdaptation.tableAdaptation(self.pageID,self.shippingDateTableSettings)
    this.shippingDateTableSettings.height = document.body.clientHeight - 100 -120;
    /**跳转到此界面接收值**/
    // if (this.$route.params.carrierName) {
    //   self.carrierName = this.$route.params.carrierName;
    //   //订舱管理-编辑
    //   if (self.carrierName !== undefined) {
    //     self.queryForm(self.carrierName);
    //   }
    // }
  },
  methods: {
    //点击
    clickModule(e) {

    },
    onPolChange(value,selectedRows){
      this.searchData.polId = selectedRows.mdPortId;
      this.searchData.polName = selectedRows.portNameEn;
      this.searchData.callingPortId = selectedRows.mdPortId;
      this.searchData.callingPortName = selectedRows.portNameEn;
    },
    onPodChange(value,selectedRows){
      this.searchData.podId = selectedRows.mdPortId;
      this.searchData.podName = selectedRows.portNameEn;
      this.searchData.portDestinationId = selectedRows.mdPortId;
      this.searchData.portDestinationName = selectedRows.portNameEn;
    },
    // pageSize 改变时会触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
      let self = this;
      self.queryStatusPage();
    },
    // currentPage 改变时会触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageConfig.currentPage = val;
      let self = this;
      self.queryStatusPage();
    },
    // 单击行事件
    rowClick(val) {
      let self = this;
      self.currentEbOrder = val.record;
    },
    // tab切换事件
    handleClick(tab, event) {
      let self = this;
      self.pageConfig.currentPage = 1;
      self.queryStatusPage();
    },
    queryStatusPage() {
      let self = this;
      // if (self.queryButton === 1) {
      //   self.queryForm();
      // } else if (self.queryButton === 2) {
      //   self.queryMoreForm();
      // }
      self.queryForm();
    },
    //重置搜索框
    resetForm() {
      this.searchData = {}
    },
    //查询
    queryForm() {
      let self = this;
      self.queryButton = 2;
      let num = 0
      for (let s in self.searchData) {
        if (self.searchData[s] !== null && self.searchData[s] !== "" && self.searchData[s] !== undefined) {
          num++;
        } else {
          delete self.searchData[s]
        }
      }
      if (num < 1) {
        self.$coreMethods.message('warning', '至少输入一个查询条件')
      }else {
        self.searchData.currentPage = self.pageConfig.currentPage;
        self.searchData.pageSize = self.pageConfig.pageSize;
        /*let voyage = self.searchData.voyage;
        self.searchData.voyage = "%"+voyage+"%";*/
        queryShippingDate(self.searchData).then((res) => {
          //self.searchData.voyage = voyage;
          if (res.success) {
            //self.shippingDateTableDataSource = res.records?.records;
            //self.pageConfig.total = res.records?.totalRecord;
            self.shippingDateTableDataSource = res.records.records;
            self.pageConfig.total = res.records.totalRecord;
            self.searchData.currentPage = null;
            self.searchData.pageSize = null;
            if (res.records.totalRecord === 0){
              self.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
            }else {
              self.$coreMethods.message("success", "查询成功！");
            }
          }
        });
      }
    },
    changeEndEtd() {
      let self = this;
      self.searchData.etdTo = new Date(self.searchData.etdTo.getTime() + 1000 * 24 * 3600 - 100)
    },
    changeEndTime() {
      let self = this;
      self.searchData.endTime = new Date(self.searchData.endTime.getTime() + 1000 * 24 * 3600 - 100)
    },
    changMoreInfoVisible() {
      let self = this
      this.moreInfoVisible = !this.moreInfoVisible
      if (this.moreInfoVisible) {
        self.ebOrderTableSettings.height= self.ebOrderTableSettings.height - 143
      } else {
        self.ebOrderTableSettings.height = self.ebOrderTableSettings.height + 143

      }
    },
    onChangeCarrie(value, selectedRows) {
      console.log(selectedRows);
      this.searchData.carrierName = selectedRows.custAlias;
      this.searchData.carrierId = selectedRows.csCustId;
    },
    onChangeVessel(value, selectedRows) {
      console.log(selectedRows);
      this.searchData.vesselName = selectedRows.vesselName;
      this.searchData.vesselId = selectedRows.mdVoyagePlanId;
      this.searchData.voyage = selectedRows.voyage;
    },
    // 船公司联想控件数据源
    associate_queryMethod_carrier({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          custType4: "%SO%",
          isDeleted6: "0",
        };
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          custType4: "%SO%",
          isDeleted6: "0",
          mdmCustCode3: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPCsCust.custNameCn"],
        mainModelName: "CTS_ILPCsCust",
        tag: "CTS_WEB_es",
        where: "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPCsCust.csCustId",
          "CTS_ILPCsCust.custAlias",
          "CTS_ILPCsCust.custNameCn",
          "CTS_ILPCsCust.custNameEn",
          "CTS_ILPCsCust.customsRegisteredNo",
          "CTS_ILPCsCust.esCustType",
          "CTS_ILPCsCust.isActive",
          "CTS_ILPCsCust.isBlacklist",
          "CTS_ILPCsCust.isCustomer",
          "CTS_ILPCsCust.isDeleted",
          "CTS_ILPCsCust.isOneTimeCustomer",
          "CTS_ILPCsCust.isSettlement",
          "CTS_ILPCsCust.isSupplier",
          "CTS_ILPCsCust.legalPerson",
          "CTS_ILPCsCust.mdmCustCode",
          "CTS_ILPCsCust.mobileNo",
          "CTS_ILPCsCust.postCode"
        ],
        enableCascade: true
      };
      return new Promise((resolve) => {
        queryCarrierInfo(data).then((res) => {
          console.log("queryCarrierInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    associate_queryMethod_vessel({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
        };
      } else {
        params = {
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.vesselName"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPMdVoyagePlan.voyage LIKE :voyage1 OR CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0)) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted2)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 航次联想控件数据源
    associate_queryMethod_voyage({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted3: "0",
        };
      } else {
        params = {
          isDeleted3: "0",
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
          voyageCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.voyage"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };

      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("queryVoyageInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 装/卸货港联想控件数据源
    associate_queryMethod_po({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          portType4: ["OP", "IP"],
          isDeleted5: "0",
        };
      } else {
        params = {
          portNameEn0: "%" + keyword + "%",
          portNameCn1: "%" + keyword + "%",
          countryCode2: "%" + keyword + "%",
          portCode3: "%" + keyword + "%",
          portType4: ["OP", "IP"],
          isDeleted5: "0",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdPort.portNameEn"],
        mainModelName: "CTS_ILPMdPort",
        tag: "CTS_ILP_es",
        where:
          "(((((CTS_ILPMdPort.portNameEn LIKE :portNameEn0 OR CTS_ILPMdPort.portNameCn LIKE :portNameCn1) OR CTS_ILPMdPort.countryCode LIKE :countryCode2) OR CTS_ILPMdPort.portCode LIKE :portCode3) AND CTS_ILPMdPort.portType IN( :portType4)) AND CTS_ILPMdPort.isDeleted = :isDeleted5)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdPort.mdPortId",
          "CTS_ILPMdPort.createOffice",
          "CTS_ILPMdPort.lastModifyOffice",
          "CTS_ILPMdPort.lastModifyOfficeName",
          "CTS_ILPMdPort.lastModifierId",
          "CTS_ILPMdPort.areaCode",
          "CTS_ILPMdPort.lineNameCn",
          "CTS_ILPMdPort.portNameEn",
          "CTS_ILPMdPort.principalGroupCode",
          "CTS_ILPMdPort.customsCode",
          "CTS_ILPMdPort.isActive",
          "CTS_ILPMdPort.createOfficeName",
          "CTS_ILPMdPort.creatorName",
          "CTS_ILPMdPort.lastModifierName",
          "CTS_ILPMdPort.appCode",
          "CTS_ILPMdPort.longitude",
          "CTS_ILPMdPort.creatorId",
          "CTS_ILPMdPort.recordVersion",
          "CTS_ILPMdPort.lastModifyTime",
          "CTS_ILPMdPort.portNameCn",
          "CTS_ILPMdPort.portCode",
          "CTS_ILPMdPort.createTime",
          "CTS_ILPMdPort.isDeleted",
          "CTS_ILPMdPort.iataCode",
          "CTS_ILPMdPort.latitude",
          "CTS_ILPMdPort.lineId",
          "CTS_ILPMdPort.countryName",
          "CTS_ILPMdPort.countryCode",
          "CTS_ILPMdPort.portType",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryPoInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
  }
}
</script>

<style scoped lang="less">

</style>
